// External libs
import { createSelector } from 'reselect';
// Tools
import { formatMessage } from '../../../intl/intl';
// Selectors
import OrdersSelectors from '../../../redux/selectors/orders-selectors';

const selectPaymentMethodAlertMessage = createSelector(
  OrdersSelectors.selectOrderDetailPaymentMethodInOrderDetailDialog,
  paymentMethod => {
    return formatMessage(
      { id: 'orderDetailDialogMarketplaceBox.paymentMethod' },
      {
        paymentMethod,
      },
    );
  },
);

const OrderDetailDialogMarketplaceBoxSelectors = {
  selectPaymentMethodAlertMessage,
};

export default OrderDetailDialogMarketplaceBoxSelectors;
